import Image, { ImageProps } from "next/image";
import React, { useRef } from "react";

export const NextImage = React.memo((props: ImageProps) => {
  const lastValidSrc = useRef<string | undefined>(props.src as string);

  // Update only if src is non-empty
  if (props.src && props.src !== "") {
    lastValidSrc.current = props.src as string;
  }

  return <Image {...props} src={lastValidSrc?.current || ""} />;
});

NextImage.displayName = "NextImage";
